import Fieldset from './Fieldset'

/* istanbul ignore next */
Fieldset.install = function (Vue) {
  Vue.component(Fieldset.name, Fieldset)
}

export default Fieldset
